<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-12 col-md-6 mb-2">
          <h2>Distributor Configuration</h2>
        </div>
        <div class="col-12 col-md-6">
          <div class="rating-container float-md-right mb-3">
            <RateCapability :qAppId="qAppIdRatingValue"></RateCapability>
          </div>
        </div>
      </div>
      <div class="row row-object">
        <div class="col-md-12 col-sm-12 one-viz-row h600">
          <QlikViz
            vizId="vvhnvuQ"
            vizTitle="Distributor Dimension mapping"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import qAPI from "../../../services/qAPI";
import page from "../../../mixins/page";
export default {
  name: "Distributors",
  props: [],
  mixins: [page],
  data() {
    return {
      pageName: this.$route.name,
      mashup: null,
      qObjects:
        "vvhnvuQ",
      qFilterObjects: [
        {
          id: "wKnfUp",
          nFilters: 1,
        },
        {
          id: "PuJZc",
          nFilters: 1,
        }
      ],
    };
  },
  async mounted() {
    var vm = this;
    await vm.init(vm.$route, vm.qObjects, vm.qFilterObjects);
  },
  async destroyed() {
    var vm = this;
    qAPI.closeQlikObjectsInStore(vm.qObjects.split(","));
  },
};
</script>